<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="card-wrap"
            style="min-height: 800px"
          >
            <component-new-header
              title="Transfer Inventory"
              :hasSearch="false"
              :hasReload="false"
              :hasRadio="false"
              :hasCreate="false"
              :hasback="false"
            />
            <b-row>
              <b-col md="5" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <eb-select
                    type="text"
                    :options="stockOptions"
                    label="label"
                    placeholder="Select From Warehouse"
                    @input="changeStockpoint"
                  ></eb-select>
                </b-form-group>
              </b-col>
              <b-col md="5" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <eb-select
                    ref="fromItem"
                    type="text"
                    :options="itemList"
                    v-model="fromItem"
                    label="label"
                    placeholder="Select Item"
                  ></eb-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <eb-select
                    ref="toStockOptions"
                    type="text"
                    :options="tostockOptions"
                    label="label"
                    placeholder="Select To Warehouse"
                    @input="changeToStockpoint"
                  ></eb-select>
                </b-form-group>
              </b-col>
              <b-col md="5" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <eb-select
                    ref="toItem"
                    type="text"
                    :options="itemList"
                    v-model="toItem"
                    label="label"
                    placeholder="Select Item"
                  ></eb-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="10" class="my-1">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <c-input
                    :inputType="'number'"
                    inputId="Quantity"
                    v-model="quantityValue"
                    lableText="Quantity"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2" class="my-1">
                <b-button
                  variant="primary"
                  :disabled="
                    !(
                      fromItem &&
                      fromItem._id &&
                      providerId &&
                      stockPointId &&
                      toStockPointId &&
                      toItem &&
                      toItem._id &&
                      toProviderId &&
                      quantityValue
                    )
                  "
                  @click="quickLoadInventory"
                  >Quick Load
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="10" class="my-1">
                <b-form-file
                  placeholder="Select a Template"
                  @change="selectFile"
                  drop-placeholder="Drop file here..."
                ></b-form-file>
              </b-col>
              <b-col md="2" class="my-1">
                <b-button
                  variant="primary"
                  :disabled="!itemId || itemId === ''"
                  @click="uploadFile"
                  >Transfer Inventory</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import { itemFindByOption } from "@/services/item";
import { getPartnerParentData } from "@/services/partner.ts";
import componentNewHeader from "@/components/componentNewHeader";
export default {
  name: "TransferInventory",
  components: {
    ebSelect,
    loader,
    cInput,
    componentNewHeader,
  },
  data: () => {
    return {
      perPage: 10,
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      itemId: "",
      providerId: "",
      stockPointId: "",
      selectedFile: null,
      stockPoint: {},
      tostockOptions: [],
      toItems: [],
      toItem: {},
      fromItem: {},
      toStockPointId: null,
      toProviderId: null,
      quantityValue: "",
      Columns: [
        {
          key: "userName",
          sortable: true,
          value: "1",
        },
        {
          key: "email",
        },
        {
          key: "phone",
        },
        {
          key: "action",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
      GetItems: "item/fetchItemsByCatalog",
      DownloadTemplate: "inventory/downloadInventoryTemplate",
      UploadFile: "inventory/uploadFileToStorage",
      LoadInventory: "inventory/loadInventory",
      TransferInventory: "inventory/transferInventory",
      TransferInventoryQuick: "inventory/transferInventoryQuick",
    }),
    quickLoadInventory() {
      let payload = {
        itemId: this.fromItem._id,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        transferToItem: this.toItem._id,
        transferToProvider: this.toProviderId,
        transferToStockPoint: this.toStockPointId,
        transferUnit: Number(this.quantityValue),
      };
      this.TransferInventoryQuick(payload)
        .then((res) => {
          this.loading = false;
          if (res.error) {
            this.$swal({
              type: "error",
              text: res.message,
            });
            return;
          }
          this.$swal({
            type: "success",
            text: "Inventory Transferred Successfully!",
          });
          this.quantityValue = null;
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            type: "error",
            text: "Failed to transfer inventory",
          });
        });
    },
    async changeStockpoint(data) {
      if (data !== null) {
        this.loading = true;
        this.getToStockPoints(data._id);
        this.stockPointId = data._id;
        const stockpointParentData = await getPartnerParentData(data._id).then(
          (x) => x.response
        );
        this.providerId = stockpointParentData._id;
        let payload = { needInventory: true };
        if (this.userCategory === "MANUFACTURER") {
          payload.manufacturerId = this.$store.getters["auth/getUserID"];
        } else {
          payload.provider = stockpointParentData._id;
        }
        await this.GetItems(payload)
          .then(() => (this.loading = false))
          .catch(() => (this.loading = false));
        this.$refs.fromItem.reset();
      }
    },
    async changeToStockpoint(data) {
      if (data !== null) {
        this.toStockPointId = data._id;
        const stockpointParentData = await getPartnerParentData(data._id).then(
          (x) => x.response
        );
        this.toProviderId = stockpointParentData._id;
        this.getToItem({
          _id: data._id,
          providerId: stockpointParentData._id,
        });
      }
    },
    getToStockPoints(Id) {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let newData = data.filter((Obj) => Obj._id !== Id);
      let userId = this.$store.getters["auth/getUserID"];
      this.tostockOptions = newData.map((obj) => ({
        _id: obj._id,
        providerId: obj.parentPartner || userId,
        label: obj.office?.officeName || "",
      }));
      this.$refs.toStockOptions.reset();
    },
    async getToItem(data) {
      let itemsData = await itemFindByOption({
        needInventory: true,
        provider: data.providerId,
      });
      this.toItems = itemsData.response.map((obj) => ({
        _id: obj._id,
        providerId: obj.provider,
        label: obj.description_summary,
      }));
      this.$refs.toItem.reset();
    },

    downloadTemplate() {
      this.loading = true;
      this.DownloadTemplate(this.itemId)
        .then((res) => {
          this.loading = false;
          const element = document.createElement("a");
          element.setAttribute(
            "href",
            window.URL.createObjectURL(new Blob([res]))
          );
          element.setAttribute("download", `${this.itemId}_template.xls`);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
        .catch(() => (this.loading = false));
    },
    selectFile(event) {
      setTimeout(() => {
        this.selectedFile = event.target.files[0];
      }, 500);
    },
    async uploadFile() {
      let formdata = new FormData();
      formdata.append("file", this.selectedFile);
      formdata.append(
        "key",
        (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase()
      );
      formdata.append("isPublic", true);
      formdata.append("replaceExisting", true);
      formdata.append("basePath", "inventory");
      await this.UploadFile(formdata)
        .then((res) => {
          this.updateInventory(res.data.fileUrl);
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            text: "File Upload failed! please try again.",
          });
          this.loading = false;
        });
    },
    updateInventory(fileUrl) {
      let payload = {
        itemId: this.itemId,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        fileUrl: fileUrl,
        transferToStockPoint: this.toStockPointId,
      };
      this.TransferInventory(payload)
        .then((res) => {
          this.loading = false;
          this.$swal({
            type: "success",
            text: "Inventory Stock Transfered Successfully!",
          });
        })
        .catch(() => (this.loading = false));
    },
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        let stockpoints = data.map((obj) => ({
          _id: obj._id,
          providerId: userId,
          label: obj.office?.officeName || "",
        }));
        return stockpoints;
      } else {
        return [];
      }
    },
    itemList() {
      let data = this.$store.getters["item/GetItemListByCatalog"];
      if (data.length > 0) {
        let items = data.map((obj) => ({
          _id: obj._id,
          providerId: obj.provider,
          label: obj.description_summary,
        }));
        return items;
      } else {
        return [];
      }
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  async mounted() {
    await this.$store.dispatch("partner/fetchAllStockPointTenant");
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
